import axios from "axios";
import { ErrorInfo, useEffect, useRef, useState } from "react";
import { api, getApiTraceId } from "@common/helpers/api";
import { removeInitialSplash } from "@common/helpers/splash";

export default function useReportError(
  error: unknown,
  info: ErrorInfo | Record<string, unknown> = {},
  getUrl: () => string,
) {
  const [traceId, setTraceId] = useState<string>();
  const reportedErrorRef = useRef<unknown>();

  useEffect(() => {
    removeInitialSplash();

    const apiTraceId = getApiTraceId(error);
    if (apiTraceId) {
      setTraceId(apiTraceId);
      return;
    }

    if (!error) {
      return;
    }

    if (axios.isAxiosError(error)) {
      return;
    }

    if (reportedErrorRef.current === error) {
      return;
    }
    reportedErrorRef.current = error;

    const reportableError =
      error instanceof Error ? error : new Error(String(error));
    api
      .post("error", {
        error: JSON.stringify(
          reportableError,
          Object.getOwnPropertyNames(reportableError),
        ),
        info,
        stack: reportableError.stack,
        url: getUrl(),
      })
      .then((response) => {
        const reportedTraceId = getApiTraceId(response.data);
        if (reportedTraceId) {
          setTraceId(reportedTraceId);
        }
      })
      .catch(() => undefined);
  }, [error, getUrl, info]);

  return traceId;
}
